export const environment = {
    production:false,
    hmr:false,
    apiUrl:'http://localhost:4000'
};